// extracted by mini-css-extract-plugin
export default {"table":"AssignedTable_table__7FyVy","title-header":"AssignedTable_title-header__cjef4","status":"AssignedTable_status__MtoHb","title":"AssignedTable_title__8ACOV"};